import {
    ConfigContent,
    ExternalDependenciesContent,
    InfoContent, ScheduledTasksContent,
} from '@backstage/plugin-devtools';
import { DevToolsLayout } from '@backstage/plugin-devtools';
import {UnprocessedEntitiesContent} from "@backstage/plugin-catalog-unprocessed-entities";
import { styled } from '@material-ui/core/styles';

const StyledDevToolsLayout = styled(DevToolsLayout)(({ theme }) => ({
  '& .MuiTypography-root': {
    color: `${theme.palette.text.primary} !important`,
  },
  '& .MuiAlert-root': {
    color: `${theme.palette.text.primary} !important`,
    '& .MuiAlert-message': {
      color: `${theme.palette.text.primary} !important`,
    },
  },
  '& .MuiAccordion-root': {
    '& .MuiTypography-root': {
      color: `${theme.palette.text.primary} !important`,
    },
    '& .MuiAccordionDetails-root': {
      '& .MuiTypography-root': {
        color: `${theme.palette.text.primary} !important`,
      },
    },
  },
  '& .MuiTableCell-root': {
    color: `${theme.palette.text.primary} !important`,
  },
  '& .MuiChip-root': {
    color: `${theme.palette.text.primary} !important`,
  },
  '& p': {
    color: `${theme.palette.text.primary} !important`,
  },
  '& h6': {
    color: `${theme.palette.text.primary} !important`,
  },
  '& code': {
    color: `${theme.palette.text.primary} !important`,
    backgroundColor: theme.palette.action.hover,
  },
  '& pre': {
    color: `${theme.palette.text.primary} !important`,
    backgroundColor: theme.palette.background.paper,
  },
}));

const DevToolsPage = () => {
    return (
        <StyledDevToolsLayout>
            <DevToolsLayout.Route path="info" title="Info">
                <InfoContent />
            </DevToolsLayout.Route>
            <DevToolsLayout.Route path="config" title="Config">
                <ConfigContent />
            </DevToolsLayout.Route>
            <DevToolsLayout.Route
                path="external-dependencies"
                title="External Dependencies"
            >
                <ExternalDependenciesContent />
            </DevToolsLayout.Route>
            <DevToolsLayout.Route path="scheduled-tasks" title="Scheduled Tasks">
                <ScheduledTasksContent/>
            </DevToolsLayout.Route>
            <DevToolsLayout.Route path="unprocessed-entities" title="Unprocessed Entities">
                <UnprocessedEntitiesContent />
            </DevToolsLayout.Route>
        </StyledDevToolsLayout>
    );
};

export const customDevToolsPage = <DevToolsPage />;